import { css } from '@emotion/css';

export const imageSmall = css`
  max-height: 16.6rem;
  max-width: 15.4rem;
`;

export const imageBig = css`
  max-height: 26rem;
  max-width: 51.2rem;
`;

export const containerBig = css`
  width: 51.2rem;
`;

export const mobileSmallImageStyles = css`
  max-height: 15rem;
`;

export const bookmarkStyles = css`
  text-decoration: none !important;
  img {
    box-shadow: none !important;
    border-radius: 0px !important;
  }
`;
